/**
 * Collapsible component
 */

/* Imports */

import React, { useLayoutEffect, useState, useRef } from "react";
import { publish, subscribe } from "../../base/pub-sub";
import {
  Collapsible,
  CollapsibleToggle,
  CollapsibleIcon,
  CollapsibleMain,
} from "./styles.module.scss";

/* Component */

const CollapsibleComponent = ({
  id = "",
  expanded = false,
  title = "",
  content = "",
  accordionGroup = "",
}) => {
  const [open, setOpen] = useState(expanded);
  const [height, setHeight] = useState(0);

  /* Elements */

  const mainEl = useRef(null);

  /* For throttling resize */

  let resizeTimer;

  /* Get main height */

  const getHeight = () => {
    if (!mainEl.current) return;

    const hStyle = mainEl.current.style.height;

    mainEl.current.style.height = "auto";

    const h = mainEl.current.clientHeight;

    mainEl.current.style.height = hStyle;

    setHeight(h);
  };

  /* Event callbacks */

  const toggle = (o) => {
    setOpen(o);

    if (accordionGroup && o) {
      publish(accordionGroup, id);
    }
  };

  const resize = () => {
    // throttles resize event
    clearTimeout(resizeTimer);

    resizeTimer = setTimeout(() => {
      getHeight();
    }, 100);
  };

  /* Reset height on resize */

  useLayoutEffect(() => {
    getHeight();

    window.addEventListener("resize", resize);

    // clean up
    return () => {
      window.removeEventListener("resize", resize);
    };
  }, []);

  /* Accordion */

  useLayoutEffect(() => {
    if (accordionGroup) {
      subscribe(accordionGroup, (openId) => {
        if (openId !== id) toggle(false);
      });
    }
  }, []);

  return (
    <div
      className={`${Collapsible} lc-collapsible lc-move-fade-y lc-vis`}
      data-expanded={open.toString()}
      data-y={expanded ? 25 : ""}
    >
      <button
        className={`${CollapsibleToggle} lc-collapsible__toggle lc-gray-alt`}
        type="button"
        aria-controls={id}
        aria-expanded={open.toString()}
        onClick={() => {
          toggle(!open);
        }}
      >
        <span
          className={`${CollapsibleIcon} lc-collapsible__icon lc-pad-h-pc-l lc-p-r lc-d-b`}
          data-size="r"
        >
          <span className="lc-h3-s lc-d-b">{title}</span>
        </span>
      </button>
      <div
        ref={mainEl}
        id={id}
        className={`${CollapsibleMain} lc-collapsible__main lc-links-r`}
        style={{ height: open && height ? `${height}px` : "" }}
      >
        <div>{content}</div>
      </div>
    </div>
  );
};

/* Export */

export default CollapsibleComponent;
